import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import CryptoJS from 'crypto-js';
import {BehaviorSubject, Observable, of} from "rxjs";
import {environment} from 'src/environments/environment';
import Swal from 'sweetalert2';

const {VENTANILLA} = environment;

/**
 * Servicio con el manejo del usuario logueado en el localStorage
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public currentUserSubject: BehaviorSubject<any>;
  public readonly currentUser$: Observable<any>;
  idActual: string;


  constructor(public http: HttpClient) {
    const valueUserSubject = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null;
    this.currentUserSubject = new BehaviorSubject<any>(valueUserSubject);
    this.currentUser$ = this.currentUserSubject.asObservable();
  }

  public getInfoToken(id: any) {
    this.http.get(`${VENTANILLA}/User/${id}`).subscribe({
      next: (value: any) => {
        this.idActual = id;
        this.setCurrentUser(value.cuurentUser, 0, value.authoritySesion, value.id);

          location.reload();
      },
      error: err => {
        console.log("no inicio sesion", err);
        localStorage.clear();
        Swal.fire({
          icon: 'error',
          confirmButtonColor: '#007bff ',
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: 'Aceptar',
          title: 'Inicio de sesión',
          text: 'debe iniciar sesion',
        });
      }
    });
  }


  public setCurrentUser(claims: any, direct?: number, authoritySesion?: any, refreshToken?: any): Observable<any> {
    if (claims) {
      if (direct == 1) {
        let tokenNuevo = this.signToken(claims['idTokenClaims'], "llaveSegura")
        const currentUser: any = {...claims['idTokenClaims'], idToken: tokenNuevo};
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        console.log(currentUser)
      } else {
        localStorage.setItem('currentUser', claims);
        localStorage.setItem('authoritySesion', authoritySesion);
        localStorage.setItem('id', refreshToken);
      }
      this.currentUserSubject.next(claims);
      return of(claims);
    }
    return of(null);
  }

  public getCurrentUser() {
    return this.currentUserSubject.value;
  }

  public getLoggedUser() {
    return localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null;
  }

  private signToken(payload: any, key: string) {
    let secret = key;
    let token: any = this.encodeToken(payload);

    let signature: any = CryptoJS.HmacSHA256(token, secret);
    signature = this.base64url(signature);

    let signedToken = token + "." + signature;
    return signedToken;
  }


  private encodeToken(payload: any) {
    let header = {
      "alg": "HS256",
      "typ": "JWT"
    };

    let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    let encodedHeader = this.base64url(stringifiedHeader);

    let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(payload));
    let encodedData = this.base64url(stringifiedData);

    let token = encodedHeader + "." + encodedData;

    return token
  }

  private base64url(source: any) {
    let encodedSource = CryptoJS.enc.Base64.stringify(source);

    encodedSource = encodedSource.replace(/=+$/, '');

    encodedSource = encodedSource.replace(/\+/g, '-');
    encodedSource = encodedSource.replace(/\//g, '_');

    return encodedSource;
  }
}
